import { COMMISSIONS_ENDPOINT } from '../../endpoints'
import axios from 'axios'

export async function deleteCommissionPolicy(id) {
    const response = await axios.put(COMMISSIONS_ENDPOINT + `/delete/${id}`);
    return response
}